import {
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[appCheckValidity]',
})
export class CheckValidityDirective {
  constructor(private renderer: Renderer2, private elementRef: ElementRef) {}

  @Input() appCheckValidity: NgModel;
  @HostBinding('class') class;

  @HostListener('change', ['$event'])
  change() {
    if (
      this.appCheckValidity.invalid &&
      (this.appCheckValidity.touched || this.appCheckValidity.dirty)
    ) {
      this.renderer.addClass(this.elementRef.nativeElement, 'is-invalid');
    } else {
      if (
        (this.elementRef.nativeElement as HTMLInputElement).classList.contains(
          'is-invalid'
        )
      ) {
        this.renderer.removeClass(this.elementRef.nativeElement, 'is-invalid');
      }
    }
  }
}
